export default __webpack_public_path__ + "static/media/seastar.b4553dcd.png";